const SESSION_MESSAGE_TYPE = {
    img: '[图片]',
    file: '[文件]',
    audio: '[语音]',
    loc: '[位置]'
}

const CUSTOM_TYPE = {
    image: '图片',
    audio: '语音',
    video: '视频',
    file: '文件',
    goods: '商品',
    inform: '系统通知',
    PayType: '待支付订单',
    PayTypeSuccess: '已支付订单',
    PayTypeAmountType: '已支付定金',
    sale_id_card:'填写账号密码'
}
const ALL_MESSAGE_TYPE = {
    TEXT: 'txt',
    IMAGE: 'img',
    AUDIO: 'audio',
    LOCAL: 'loc',
    VIDEO: 'video',
    FILE: 'file',
    CUSTOM: 'custom',
    CMD: 'cmd',
    INFORM: 'inform', //这个类型不在旧IM消息类型内，属于自己定义的一种系统通知类的消息。
    GOODS: 'goods'
}
const CHAT_TYPE = {
    SINGLE: 'singleChat',
    GROUP: 'groupChat'
}

export default {
    SESSION_MESSAGE_TYPE,
    CUSTOM_TYPE,
    ALL_MESSAGE_TYPE,
    CHAT_TYPE
}
